// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import type { Breakpoint } from '@mui/material/styles';
// biome-ignore lint/style/useImportType: <explanation>
import React from 'react';
import { Box } from '../../../lib/base';

export interface VisibleAtContainerProps {
  readonly up: React.ReactNode;
  readonly down: React.ReactNode;
  readonly visibleAt?: Breakpoint;
  readonly containerName?: string;
}

export function VisibleAtContainer({ up, down, visibleAt = 'sm', containerName }: VisibleAtContainerProps) {
  const maybeContainerName = containerName === undefined ? '' : `/${containerName}`;
  return (
    <>
      <Box
        sx={{
          display: {
            xs: 'none',
            [visibleAt]: 'block',
            [`@xs${maybeContainerName}`]: 'none',
            [`@${visibleAt}${maybeContainerName}`]: 'block',
          },
        }}
      >
        {up}
      </Box>
      <Box
        sx={{
          display: {
            xs: 'block',
            [visibleAt]: 'none',
            [`@xs${maybeContainerName}`]: 'block',
            [`@${visibleAt}${maybeContainerName}`]: 'none',
          },
        }}
      >
        {down}
      </Box>
    </>
  );
}
